module.exports = __webpack_public_path__ + "fonts/Graphik-Extralight.1358cdd5.woff2";